module.exports = __webpack_public_path__ + "static/media/banner-4.441d649a.jpeg";